import $, { css, get } from "jquery";
$(function () {
  updateCartCount();
  //show mini-hap and overlay
  $(".icon-cart-header .cart-link").on("click", function (e) {
    const isCartPage = $(".header-cart").data("is-cart-page");

    if (isCartPage === false || isCartPage === "false") {
      e.preventDefault();
      $(".mini-cart").toggleClass("active");
      $(".mini-cart-overlay").toggleClass("active"); //show/hide overlay
    }
  });

  //Closure of the basket and overlay
  $(".mini-cart").on("click", ".close-cart", function () {
    $(".mini-cart").removeClass("active");
    $(".mini-cart-overlay").removeClass("active");
  });

  //Closing at click on Overlay
  $(".mini-cart-overlay").on("click", function () {
    $(".mini-cart").removeClass("active");
    $(this).removeClass("active");
  });
  //Free a meter upgrade
  function updateCartCount() {
    $.post(
      ajax_object.ajaxurl,
      { action: "get_cart_count" },
      function (response) {
        if (response.success) {
          const count = parseInt(response.data.count) || 0;
          $(".cart-count").text(count).css("display", "inline-flex");
        }
      }
    );
  }

  $(document).on(
    "click",
    ".products-loop .product-card .size-option",
    function (e) {
      let $clickedOption = $(this);
      let $productCard = $clickedOption.closest(".product-card");
      let $sizeGroup = $clickedOption.closest(".size-buttons");

      //remove the choice of size in all other cards (without changing the price)
      $(".products-loop .product-card")
        .not($productCard)
        .each(function () {
          let $otherCard = $(this);
          $otherCard.find(".size-option").removeClass("selected");
          $otherCard
            .find(".size-buttons")
            .removeAttr("data-selected-size data-variation-id");
          $otherCard.find(".product-card__sizes .size-error").remove();
        });

      // Cleaning the choice in this card
      $sizeGroup.find(".size-option").removeClass("selected");
      $sizeGroup.removeAttr("data-selected-size data-variation-id");
      $productCard.find(".product-card__sizes .size-error").remove();

      // Setting a new selected size
      $clickedOption.addClass("selected");
      let selectedSize = $clickedOption.data("size");
      let variationId = $clickedOption.data("variation_id");

      $sizeGroup.attr("data-selected-size", selectedSize);
      $sizeGroup.attr("data-variation-id", variationId);

      // Price update
      let selectedRegularPrice = $clickedOption.data("price") || 0;
      let selectedSalePrice = $clickedOption.data("sale_price") || 0;
      let $priceContainer = $productCard.find(".product-price-value");

      if (selectedRegularPrice > 0) {
        if (selectedSalePrice > 0 && selectedSalePrice < selectedRegularPrice) {
          $priceContainer.html(
            "<del>" +
            selectedRegularPrice +
            "<span> грн</span></del> " +
            "<ins>" +
            selectedSalePrice +
            "<span> грн</span></ins>"
          );
        } else {
          $priceContainer.html(
            "<ins>" + selectedRegularPrice + "<span> грн</span></ins>"
          );
        }
      }
    }
  );

  //Reset the choice of click outside the cards
  $(document).on("click", function (e) {
    if ($(e.target).closest(".product-card").length === 0) {
      $(".products-loop .product-card").each(function () {
        let $card = $(this);
        $card.find(".size-option").removeClass("selected");
        $card
          .find(".size-buttons")
          .removeAttr("data-selected-size data-variation-id");
        $card.find(".product-card__sizes .size-error").remove();
        //We do not change the price
      });
    }
  });

  $(document).on("click", ".product-summary .size-option", function () {
    let $sizeGroup = $(this).closest(".size-buttons");
    $sizeGroup.find(".size-option").removeClass("selected");
    $(this).addClass("selected");
    $sizeGroup.attr("data-selected-size", $(this).data("size"));
    $sizeGroup.attr("data-variation-id", $(this).data("variation_id"));

    let selectedRegularPrice = $(this).data("price");
    let selectedSalePrice = $(this).data("sale_price");
    let stockQty = $(this).data("stock_qty"); //  We get a quantity

    //  We update the block with the number
    let $stockInfo = $(".stock-info");
    if (stockQty > 0) {
      $stockInfo
        .removeClass("out-of-stock")
        .addClass("in-stock")
        .text("В наявності: " + stockQty + " шт.");
    } else {
      $stockInfo
        .removeClass("in-stock")
        .addClass("out-of-stock")
        .text("Немає в наявності");
    }

    if (selectedRegularPrice) {
      if (
        selectedSalePrice &&
        selectedSalePrice !== "0" &&
        selectedSalePrice < selectedRegularPrice
      ) {
        $("#product-price-value").html(
          "<del>" +
          selectedRegularPrice +
          '<span class="woocommerce-Price-currencySymbol"> грн</span></del> ' +
          "<ins>" +
          selectedSalePrice +
          '<span class="woocommerce-Price-currencySymbol"> грн</span></ins>'
        );
      } else {
        $("#product-price-value").html(
          "<ins>" +
          selectedSalePrice +
          '<span class="woocommerce-Price-currencySymbol"> грн</span></ins>'
        );
      }
    } else {
      $("#product-price-value").html(
        '<?php echo addslashes(preg_replace("/(\\d+)(\\s*)(грн)/iu", "$1<span> $3</span>", $product->get_price_html())); ?>'
      );
    }
  });

  $(document).on("click", ".add-to-cart-button", function (e) {
    e.preventDefault();

    let product_id = $(this).data("product_id");
    let $productCard = $(this).closest(".product-card");
    let $sizeGroup = $productCard.find(".size-buttons");

    let data = {
      action: "ajax_add_to_cart",
      product_id: product_id,
    };

    //If the item is variable, we check the choice of size
    if ($sizeGroup.length > 0) {
      let selectedSize = $sizeGroup.attr("data-selected-size");
      let variation_id = $sizeGroup.attr("data-variation-id");

      if (!selectedSize || !variation_id) {
        //If the size is not selected, show the error
        if (!$sizeGroup.find(".size-error").length) {
          $sizeGroup.append('<div class="size-error">Оберіть розмір</div>');
        }
        return;
      }

      data.variation_id = variation_id;
      data.size = selectedSize;
    }

    $.ajax({
      type: "POST",
      url: ajax_object.ajaxurl,
      data: data,
      success: function (response) {
        if (response.success) {
          $(".mini-cart-content").html(
            response.data.fragments[".mini-cart-content"]
          );
          $(".mini-cart").toggleClass("active");
          $(".mini-cart-overlay").toggleClass("active");
          updateCartCount();
          //Cleaning the selected size
          $sizeGroup.removeAttr("data-selected-size data-variation-id");
          $sizeGroup.find(".size-option").removeClass("selected");
          $sizeGroup.find(".size-error").remove();

          //Checking the balance and cross -out if it was the last
          let selectedButton = $sizeGroup.find(
            '.size-option[data-variation_id="' + data.variation_id + '"]'
          );

          let stockQty = parseInt(selectedButton.data("stock_qty")) || 0;

          // if (stockQty === 1) {
          //   //If it was the last unit -to cross and block
          //   selectedButton
          //     .addClass("depleted")
          //     .attr("disabled", true)
          //     .removeClass("selected");
          // } else if (stockQty > 1) {
          //   //Alternatively, you can reduce the locally counter if required
          //   selectedButton.data("stock_qty", stockQty - 1);
          // }

          // showToast("Товар додано в кошик!", "success");
          // Updating the state of variations after adding
          updateDepletedVariations();
        } else {
          showToast("⚠️ " + response.data.message, "error");
          $sizeGroup.removeAttr("data-selected-size data-variation-id");
          $sizeGroup.find(".size-option").removeClass("selected");
          $sizeGroup.find(".size-error").remove();
        }
      },
      error: function () {
        showToast("Сталася помилка. Спробуйте ще раз.", "error");
      },
    });
  });
  updateDepletedVariations();
  /** ---------- Test -------------------- */
  function updateDepletedVariations() {
    $.ajax({
      type: "POST",
      url: ajax_object.ajaxurl,
      data: {
        action: "get_cart_variations",
      },
      success: function (response) {
        if (response.success && response.data) {
          let cartVariations = response.data;

          $(".product-card").each(function () {
            let $card = $(this);
            let $sizeButtons = $card.find(".size-option");

            if ($sizeButtons.length > 0) {
              // Variative product
              let allDepleted = true;

              $sizeButtons.each(function () {
                let $btn = $(this);
                let variationId = $btn.data("variation_id");
                let stockQty = parseInt($btn.data("stock_qty")) || 0;
                let cartQty = cartVariations[variationId] || 0;

                if (cartQty >= stockQty) {
                  $btn
                    .addClass("depleted")
                    .attr("disabled", "disabled")
                    .attr("aria-disabled", "true");
                } else {
                  $btn
                    .removeClass("depleted")
                    .removeAttr("disabled")
                    .removeAttr("aria-disabled");
                  allDepleted = false;
                }
              });

              if (allDepleted) {
                $card
                  .find(".add-to-cart-button")
                  .attr("disabled", "disabled")
                  .attr("aria-disabled", "true")
                  .addClass("disabled");
              } else {
                $card
                  .find(".add-to-cart-button")
                  .removeAttr("disabled")
                  .removeAttr("aria-disabled")
                  .removeClass("disabled");
              }
            } else {
              // Simple goods
              let $btn = $card.find(".add-to-cart-button");
              let productId = $btn.data("product_id");
              let stockQty = parseInt($btn.data("stock_qty")) || 0;
              let cartQty = cartVariations[productId] || 0;

              if (cartQty >= stockQty || stockQty === 0) {
                $btn
                  .attr("disabled", "disabled")
                  .attr("aria-disabled", "true")
                  .addClass("disabled");
              } else {
                $btn
                  .removeAttr("disabled")
                  .removeAttr("aria-disabled")
                  .removeClass("disabled");
              }
            }
          });
        }
      },
    });
  }

  //function to display toast messages
  function showToast(message, type) {
    let toastClass = type === "success" ? "toast-success" : "toast-error";

    let toast = $(
      '<div class="toast ' + toastClass + '">' + message + "</div>"
    );
    $("body").append(toast);

    setTimeout(function () {
      toast.fadeOut(500, function () {
        $(this).remove();
      });
    }, 3000);
  }

  // Update the quantity of goods
  $(".mini-cart").on("change", ".quantity input", function () {
    const $input = $(this);
    const cart_item_key = $input.data("cart_item_key");
    const quantity = $input.val();

    $.post(
      ajax_object.ajaxurl,
      { action: "update_cart_item_quantity", cart_item_key, quantity },
      function (response) {
        if (
          response.success &&
          response.data?.fragments?.[".mini-cart-content"]
        ) {
          $(".mini-cart-content").html(
            response.data.fragments[".mini-cart-content"]
          );
          updateCartCount();
        }
      }
    );
  });

  //Deleting the goods without rebooting page and closing mini-hap
  $(".mini-cart").on("click", ".remove_from_cart_button", function (e) {
    e.preventDefault();

    const cart_item_key = $(this).data("cart_item_key");
    const $item = $(this).closest(".woocommerce-mini-cart-item");
    const product_id = $item.data("product_id");
    const variationId = $(this).data("variation_id");

    $.ajax({
      url: ajax_object.ajaxurl,
      type: "POST",
      data: {
        action: "ajax_remove_from_cart",
        cart_item_key: cart_item_key,
      },
      success: function (response) {
        if (
          response.success &&
          response.data?.fragments?.[".mini-cart-content"]
        ) {
          $(".mini-cart-content").html(
            response.data.fragments[".mini-cart-content"]
          );

          updateCartCount();
          updateDepletedVariations();

          //  If there is a variation_id -we check it out Stock separately
          if (variationId) {
            $.ajax({
              url: ajax_object.ajaxurl,
              type: "POST",
              data: {
                action: "get_variation_stock_status",
                variation_id: variationId,
              },
              success: function (res) {
                if (res.success && res.data) {
                  const $button = $(
                    '.size-option[data-variation_id="' + variationId + '"]'
                  );
                  if (res.data.depleted) {
                    $button
                      .addClass("depleted")
                      .attr("disabled", true)
                      .removeClass("selected");
                  } else {
                    $button.removeClass("depleted").removeAttr("disabled");
                  }
                }
              },
            });
          }
        } else {
          console.error("Помилка оновлення корзини.");
        }
      },
      error: function (xhr, status, error) {
        console.error("AJAX помилка видалення товару:", error);
      },
    });
  });

  //Update buttons plus/minus
  function updateQuantityButtons($input) {
    const quantity = parseInt($input.val());
    const maxQuantity = parseInt($input.attr("max"));
    const $counter = $input.closest(".quantity-counter");
    const $minus = $counter.find(".minus");
    const $plus = $counter.find(".plus");

    $minus.prop("disabled", quantity <= 1);
    $plus.prop("disabled", quantity >= maxQuantity);
  }

  //processing click on buttons
  $(".mini-cart").on("click", ".quantity-btn", function () {
    const $counter = $(this).closest(".quantity-counter");
    const $input = $counter.find(".quantity-input");
    const cart_item_key = $counter.data("cart_item_key");
    let quantity = parseInt($input.val());
    const maxQuantity = parseInt($input.attr("max"));

    if ($(this).hasClass("plus") && quantity < maxQuantity) {
      quantity += 1;
    } else if ($(this).hasClass("minus") && quantity > 1) {
      quantity -= 1;
    }

    $input.val(quantity);
    updateQuantityButtons($input);

    $.post(
      ajax_object.ajaxurl,
      { action: "update_cart_item_quantity", cart_item_key, quantity },
      function (response) {
        if (
          response.success &&
          response.data?.fragments?.[".mini-cart-content"]
        ) {
          $(".mini-cart-content").html(
            response.data.fragments[".mini-cart-content"]
          );
          updateCartCount();
        }
      }
    );
  });

  //Initialization of the buttons when loaded
  $(".quantity-input").each(function () {
    updateQuantityButtons($(this));
  });

  // Update Counter Update when Loading
  updateCartCount();

  $("body").on("change", ".woocommerce-cart-form input.qty", function () {
    let qtyInput = $(this);
    let row = qtyInput.closest("tr"); //find a line of goods
    let removeBtn = row.find(".remove"); //Looking for a removal button

    if (!removeBtn.length) {
      return;
    }

    let cartItemKey = removeBtn.attr("href");

    if (!cartItemKey) {
      return;
    }

    //Delete extra parameters (eg _wpnonce)
    cartItemKey = cartItemKey.split("remove_item=")[1]?.split("&")[0];

    if (!cartItemKey) {
      return;
    }

    let quantity = qtyInput.val();

    $.ajax({
      type: "POST",
      url: ajax_object.ajaxurl,
      data: {
        action: "update_cart",
        security: ajax_object.nonce,
        cart_item_key: cartItemKey,
        cart_qty: quantity,
      },
      success: function (response) {
        if (response.success) {
          //Update the widget of the basket and the results
          $(document.body).trigger("wc_update_cart");
          $(document.body).trigger("wc_fragment_refresh");

          // Update the Basket Summary Block
          $(".cart_totals").load(window.location.href + " .cart_totals > *");
          $(".woocommerce-cart-form").load(
            window.location.href + " .woocommerce-cart-form > *"
          );
        } else {
          console.error("Basket Update Failed:", response.data);
        }
      },
    });
  });

  $("body").on("click", ".quantity-minus, .quantity-plus", function () {
    let $button = $(this);
    let $input = $button.siblings(".qty-input");
    let oldValue = parseInt($input.val());
    let newValue = oldValue;
    let maxValue = parseInt($input.attr("max")) || 1;
    let minValue = parseInt($input.attr("min")) || 1;

    if ($button.hasClass("quantity-minus")) {
      newValue = oldValue > minValue ? oldValue - 1 : minValue;
    } else if ($button.hasClass("quantity-plus")) {
      newValue = oldValue < maxValue ? oldValue + 1 : maxValue;
    }

    //Update value
    $input.val(newValue).trigger("change");

    // Activate or block buttons only within the current item
    let $quantityWrapper = $button.closest(".quantity-wrapper");
    let $plusBtn = $quantityWrapper.find(".quantity-plus");
    let $minusBtn = $quantityWrapper.find(".quantity-minus");

    $plusBtn.prop("disabled", newValue >= maxValue);
    $minusBtn.prop("disabled", newValue <= minValue);
    let $row = $button.closest("tr");
    // We count the price
    let priceText = "";

    if ($row.find(".product-price ins .amount").length) {
      priceText = $row.find(".product-price ins .amount").text().trim();
    } else {
      priceText = $row
        .find(".product-price .amount")
        .not("del .amount")
        .first()
        .text()
        .trim();
    }

    let pricePerUnit = parseFloat(
      priceText.replace(/[^0-9.,]/g, "").replace(",", ".")
    );

    if (isNaN(pricePerUnit) || pricePerUnit <= 0) {
      console.error("Помилка отримання ціни:", priceText);
      return;
    }

    let newSubtotal = (pricePerUnit * newValue).toFixed(2);
    newSubtotal = newSubtotal.replace(/\.00$/, "");

    $row.find(".product-subtotal span.amount").text(newSubtotal + " грн");

    //Ajax update
    $.ajax({
      type: "POST",
      url: ajax_object.ajaxurl,
      data: {
        action: "update_cart",
        security: ajax_object.nonce,
        cart_item_key: $button.data("cart-item-key"),
        cart_qty: newValue,
      },
      success: function (response) {
        if (response.success) {
          $(document.body).trigger("wc_fragment_refresh");
          $(".cart_totals").load(window.location.href + " .cart_totals > *");
        } else {
          console.error("Помилка оновлення кошика:", response.data);
        }
      },
    });
  });

  $("body").on("input", ".qty-input", function () {
    let $input = $(this);
    let min = parseInt($input.attr("min")) || 1;
    let max = parseInt($input.attr("max")) || 100;
    let value = $input.val().replace(/[^0-9]/g, ""); //We delete all non -numerical characters

    //we prohibit the introduction more than allowed `max` '
    if (parseInt(value) > max) {
      value = max;
    }

    //If the user entered the number less than `min`, we put the minimum value
    if (value === "" || parseInt(value) < min) {
      value = min;
    }

    $input.val(value);
  });

  //prohibit copying/inserting non -digital characters
  $("body").on("paste", ".qty-input", function (e) {
    e.preventDefault();
  });
});
